import axios from 'axios';
import config from '../config';

export const deleteOnboardDevice = (deviceId: string) => {
    return axios.delete(`${config.API_URL}/onboard-devices/${deviceId}`, {}).then((response: any) => {
        return response.data.message;
    });
};
